// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCgCKFrcdFxQ9pkuqiJZpu4FMddWFm2xx8",
  authDomain: "devil-rank.firebaseapp.com",
  databaseURL: "https://devil-rank-default-rtdb.firebaseio.com",
  projectId: "devil-rank",
  storageBucket: "devil-rank.appspot.com",
  messagingSenderId: "741440117277",
  appId: "1:741440117277:web:3441be6ea8baa16143c4f4",
  measurementId: "G-ZRD6CD4KMN",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);

export { app, analytics, auth, db, functions };
